export const USE_POINTS_FILTER_VISIBILITY = {
    NOT_SHOW_USE_POINTS_FILTERS: 'notShowUsePointsFilters',
    SHOW_USE_POINTS_FILTER_BOTH: 'showUsePointsFilterBoth',
    SHOW_USE_POINTS_FILTER_PANEL_ONLY: 'showUsePointsFilterPanelOnly'
};

export const USE_POINTS_FILTER_UNCHECKED = {
    SHOW_USE_POINTS_BOTH: 'showUsePointsBoth',
    SHOW_REGULAR_ONLY: 'showRegularOnly'
};

export const USE_POINTS_FILTER_PRESELECTION = {
    USE_POINTS_CHECKED: true,
    USE_POINTS_NOT_CHECKED: false
};



// WEBPACK FOOTER //
// ./src/constants/UsePointsTypes.js